import { render, staticRenderFns } from "./short-reference-search-cn.vue?vue&type=template&id=13d2da98&"
import script from "./short-reference-search-cn.vue?vue&type=script&lang=js&"
export * from "./short-reference-search-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports